import * as _ from 'lodash';

import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog} from '@angular/material/dialog';
import { StateService } from '@uirouter/core';
import { ControlService } from '../control/control.service';
import { DeviceService } from '../shared/services/device.service';
import { DeviceInformation } from '../shared/models/device-information';
import { DeviceModelService } from '../shared/services/device-model.service';
import { CurrentInfoChangeConfirmationComponent } from '../current-info-change-confirmation/current-info-change-confirmation.component';
import { TemplateChoiceDialogComponent } from '../template-choice-dialog/template-choice-dialog.component';
import { TemplateNameDialogComponent } from '../template-name-dialog/template-name-dialog.component';
import { UpdateConfirmationDialogComponent } from '../update-confirmation-dialog/update-confirmation-dialog.component';
import { IDeviceInformation, IDeviceNode } from '../shared/models/device';
import { DeviceSettingsBaseComponent } from '../device-settings-base/device-settings-base.component';
import { CurrentInfoService } from './current-info.service';
import { MessageType } from '@caslink/common-client';
import { UserPermissionService } from '@caslink/common-client/ng-app/userPermission/UserPermissionService';
import { CaalFileDialogComponent } from '../caal-file-dialog/caal-file-dialog.component';
import { IJobDocumentTreeNodeViewModel } from '../shared/models/nola-job-document-models';
import { DialogService } from '@caslink/common-client/ng-app/dialog-service/dialog.service';
import { DashboardToastrConfirmationService } from '../shared/services/dashboard-toastr-confirmation.service';
import { DeviceUpdateAction } from '../shared/models/models';

@Component({
    selector: 'dl-current-info',
    templateUrl: './current-info.component.html'
})
export class CurrentInfoComponent extends DeviceSettingsBaseComponent implements OnInit {
    public static $name: string = 'currentInfo';

    constructor(
        public cdr: ChangeDetectorRef,
        private currentInfoService: CurrentInfoService,
        private deviceService: DeviceService,
        protected matDialog: MatDialog,
        private dialogService: DialogService,
        protected $state: StateService,
        protected controlService: ControlService,
        protected deviceModelService: DeviceModelService,
        private userPermissionService: UserPermissionService,
        protected dashboardToastrConfirmationService: DashboardToastrConfirmationService,
    ) {
        super($state, deviceModelService, controlService, matDialog, dashboardToastrConfirmationService);
    }

    public currentInfoForm: FormGroup;
    canManageTemplates: boolean;
    canImportFromCAALFile: boolean;
    templateApplied: boolean;

    updateWarning: string;
    public hasCAALManagementPermission: Boolean = false;
    public isCommissionerModelSupported: Boolean = false;

    public ngOnInit() {
        this.modelName = 'Current Information';

        this.currentInfoForm = new FormGroup({});

        this.SetCanManageTemplates();

        this.getHasCAALManagementPermission();

        this.loadCurrent();
    }

    public selectTemplate() {


        const dialogRef = this.dialogService.showDialogView(TemplateChoiceDialogComponent, {
            data: {
                category: (this.deviceInformation.$deviceHierarchy.identifier as any).actorType,
                templateType: 'CurrentInformation',
                locationId: this.locationId
            }
        });

        dialogRef.afterClosed().toPromise().then((result: string) => {
            if (result != null) {

                this.currentInfoForm = new FormGroup({});

                this.isLoaded = false;

                this.currentInfoService.applyCurrentInformationTemplate(this.deviceInformation, this.hardwareItemId, result).then((node: IDeviceNode) => {
                    this.deviceInformation = this.deviceService.setupDeviceInfo(node);
                    this.originalDeviceInformation = _.cloneDeep(this.deviceInformation);
                    this.isLoaded = true;
                    this.templateApplied = true;
                });

            }
        });

    }

    public makeTemplate() {

        const hasChanges: boolean = !((!this.currentInfoForm.dirty || this.currentInfoForm.invalid) && !this.templateApplied);

        const dialogRef = this.matDialog.open(TemplateNameDialogComponent, {
            height: '250px',
            data: {
                template: '',
                fullsnapshot: !hasChanges,
                disabled: !hasChanges
            }
        });

        dialogRef.afterClosed().toPromise().then((result: any) => {
            if (result != null) {

                this.currentInfoService.saveCurrentInformationTemplate(this.deviceInformation, this.hardwareItemId, result.template, result.fullsnapshot).then(() => {
                    // do nothing
                });

            }
        });

    }

    private getUpdateWarning(): string {
        let defaultWarning = 'This action may trigger a system reboot at the site.';
        return defaultWarning + (this.updateWarning ? ` ${this.updateWarning}.` : '') + ' Are you sure?';
    }

    public confirmUpdateCurrentInfoEx() {

        this.currentInfoService.previewCurrentInformationTemplate(this.deviceInformation, this.hardwareItemId, "preview", false).then((preview) => {




            const dialogRef = this.matDialog.open(UpdateConfirmationDialogComponent, {
                data: {
                    dialogConfirmOptions: {
                        title: 'SETTINGS', /*this.modelName,*/
                        message: this.getUpdateWarning(),
                        messageType: MessageType.Warning
                    },
                    preview: preview
                }
            });


            dialogRef.afterClosed().toPromise().then((result: string) => {
                if (result != null) {

                    this.updateCurrentInfo(result);

                }
            });


        });

    }


    public updateCurrentInfoEx() {

        this.userPermissionService.getHasAccess("Settings.NoteRequiredForControlUpdate")
            .then((hasAccess: boolean) => {

                if (hasAccess) {

                    this.confirmUpdateCurrentInfoEx();

                } else {
                    this.updateCurrentInfo(null);
                }


            });


    }


    public updateCurrentInfo(note : string) {
        this.updateDevice(this.loadCurrent, DeviceUpdateAction.CURRENT_INFORMATION, note);
    }

    public setDeviceInfo = (deviceInfo: DeviceInformation | IDeviceInformation) => {
        this.isLoaded = false;
        this.cdr.detectChanges();

        const isDirty = this.currentInfoForm.dirty;
        // recreate the form to prevent old data and related errors from persisting.
        this.currentInfoForm = new FormGroup({});

        this.deviceInformation = deviceInfo;
        this.isLoaded = true;
        this.cdr.detectChanges();

        if (isDirty) {
            this.currentInfoForm.markAsDirty();
            this.currentInfoForm.markAsTouched();
        }
    }

    private SetCanManageTemplates() {
        this.currentInfoService.getCanManageTemplates().then((result) => {
            this.canManageTemplates = result;
        });
    }

    // Delegate to the device service to load the current information.
    private loadCurrent(): angular.IPromise<IDeviceInformation> {
        this.isLoaded = false;

        return this.currentInfoService.getCurrentInformation(this.hardwareItemId).then((node: IDeviceNode) => {
            this.deviceInformation = this.deviceService.setupDeviceInfo(node);
            this.canImportFromCAALFile = this.deviceInformation.$deviceHierarchy.jobNumber != null;
            this.originalDeviceInformation = _.cloneDeep(this.deviceInformation);
            this.isLoaded = true;

            this.templateApplied = false;

            this.SetIsCommissionerModelSupported();

            return this.deviceInformation;
        });
    }

    public onImportFromCAALFileClick() {
        const dialogRef = this.matDialog.open(CaalFileDialogComponent, {
            data: {
                caption: 'Please select Caal file for import',
                hardwareItemId: this.deviceInformation.$deviceHierarchy.identifier.entityId,
                selectedNodeData: null
            }
        });

        dialogRef.afterClosed().toPromise().then((result: any) => {
            if (result != null && result.selectedNodeData != null) {
                const selectedNodeData: IJobDocumentTreeNodeViewModel = result.selectedNodeData;

                this.currentInfoForm = new FormGroup({});

                this.isLoaded = false;

                this.currentInfoService.importCaalToCurrentInformation(this.deviceInformation, this.hardwareItemId, selectedNodeData.documentId).then((node: IDeviceNode) => {
                    this.deviceInformation = this.deviceService.setupDeviceInfo(node);
                    this.originalDeviceInformation = _.cloneDeep(this.deviceInformation);
                    this.isLoaded = true;
                });
            }
        });
    }

    private getHasCAALManagementPermission() {
        this.userPermissionService.getHasAccess('Controls.AllowCAALManagement')
            .then((hasAccess: boolean) => {
                this.hasCAALManagementPermission = hasAccess;


            });

    }

    private SetIsCommissionerModelSupported() {
        this.currentInfoService.getIsCommissionerModelSupported(this.deviceInformation).then((result) => {
            this.isCommissionerModelSupported = result;
        });
    }

}
